import ViewRfqQuote from '../../../../../../client/src/rfq/src/viewmodel/ViewRfqQuoteViewModel';
import { DesBaseRfqQuote } from '../utils/des-base-rfq-quote';

export default class DesViewRfqQuote extends DesBaseRfqQuote {

    constructor() {
        console.log('DesViewRfqQuote invoked');
        super(ViewRfqQuote);
    }

    static get observedAttributes() {
        return [ ...DesBaseRfqQuote.observedAttributes ];
    }
}

if (!window.customElements.get('des-view-rfq-quote')) {
    window.customElements.define('des-view-rfq-quote', DesViewRfqQuote);
}
